import { render, staticRenderFns } from "./imgK.vue?vue&type=template&id=777804e4&scoped=true"
var script = {}
import style0 from "./imgK.vue?vue&type=style&index=0&id=777804e4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777804e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('777804e4')) {
      api.createRecord('777804e4', component.options)
    } else {
      api.reload('777804e4', component.options)
    }
    module.hot.accept("./imgK.vue?vue&type=template&id=777804e4&scoped=true", function () {
      api.rerender('777804e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgK.vue"
export default component.exports